export type SywmAddOptions = {
	epi: number
	empi: number
	du: string
}

type WishlistContents = {
	di: string
	bt: string
	dt: string
	cts: number
	empi: number
	sku: string
	lid: string
	du: string
	pid: string
	epi: number
	id: string
	uts: number
	iu: string
	uby: number | null
	pr: number
}

type Wishlist = {
	di: string
	listcontents: WishlistContents[]
	lty: string
	cts: number
	cnt: number
	lname: string
	cby: number | null
	lid: string
	pid: string
	uts: number
	uby: number | null
}

type CreateListConfig = {
	lname: string
	lnote?: string
	lprops?: Record<string, string>
	fromlid?: string
	lty?: 'wl' | 'sfl'
}

// Call `fetchLists` function

function onSwymLoadCallback(swat: any) {
	if (!window.UcoastSwym) {
		window.UcoastSwym = new UcoastSwym(swat)
	}
}
export function initSwym() {
	if (!window.SwymCallbacks) {
		window.SwymCallbacks = []
	}
	window.SwymCallbacks.push(onSwymLoadCallback)
}

export class UcoastSwym {
	swat: any
	wishlists?: Wishlist[] = undefined
	onFetchSuccess: (lists: Wishlist[]) => void
	onFetchError: (error: string) => void
	onCreateSuccess: (wishlist: Wishlist) => void
	onCreateError: (error: string) => void
	addItemCallback: (
		options: SywmAddOptions,
		onSuccess: (addedListItem: boolean) => void,
		onError: (error: string) => void
	) => void

	constructor(swat: any) {
		this.swat = swat
		this.onFetchSuccess = function (lists: Wishlist[]) {
			if (lists.length) {
				this.wishlists = lists
				return
			}
			const listConfig = {
				lname: 'My Wishlist',
			} satisfies CreateListConfig
			swat.createList(
				listConfig,
				this.onCreateSuccess,
				this.onCreateError
			)
		}
		this.onFetchError = function (error: string) {
			console.log('Error while fetching all Lists', error)
		}
		this.onCreateSuccess = function (wishlist: Wishlist) {
			if (!this.wishlists) {
				this.wishlists = []
			}
			this.wishlists?.push(wishlist)
		}
		this.onCreateError = function (error: string) {
			console.log('Error while creating List', error)
		}
		this.addItemCallback = function (
			options: SywmAddOptions,
			onSuccess: (addedListItem: boolean) => void,
			onError: (error: string) => void
		) {
			if (!this.wishlists) {
				throw new Error('Wishlists not loaded')
			}
			const product = options
			const lid = this.wishlists[0].lid
			swat.addToList(lid, product, onSuccess, onError)
		}

		swat.fetchLists({
			callbackFn: this.onFetchSuccess.bind(this),
			errorFn: this.onFetchError.bind(this),
		})
	}
}
